import React from 'react';
import { volumes } from '../data/teknik';

// Neutral CSS placeholders, only shown if an image slot in data/teknik.ts is empty.
export function ProductBoxPlaceholder({
  className = ''
}: {
  className?: string;
}) {
  return <div role="img" aria-label="ВЕРОНАУКА СПРЕМНА™ – 6 дигиталних томова веронауке за 1–8. разред" className={`relative mx-auto w-full max-w-sm ${className}`} data-id="element-263" data-mp="1eth7ru44zxx7">
      <div className="rounded-2xl bg-[#111111] p-5 text-white shadow-2xl shadow-slate-900/30" data-id="element-264" data-mp="15tkmm2gyhh6w">
        <p className="text-xs font-semibold uppercase tracking-widest text-white/70" data-id="element-265" data-mp="10ur8q8xrbo67">1–8. разред</p>
        <p className="mt-1 font-serif text-4xl leading-none tracking-tight" data-id="element-266" data-mp="vvoab7ca8g77">ВЕРОНАУКА СПРЕМНА<span className="align-super text-[0.45em]" data-id="element-267" data-mp="vxhlmzxubolj">™</span></p>
        <p className="mt-2 text-sm leading-snug text-white/80" data-id="element-268" data-mp="qxv5oiqmnu91">Веронаука · Празници · Вредности</p>
        <div className="mt-5 grid grid-cols-6 gap-1.5" data-id="element-269" data-mp="2q8e4lq6kbrf4">
          {volumes.map(v => <div key={v.number} className={`flex h-36 flex-col justify-between rounded-md border-r-4 border-black/10 p-1.5 ${v.spine}`} data-id="element-270" data-mp="2lacqzkrwokb1">
              <span className="text-[9px] font-bold opacity-80" data-id="element-271" data-mp="2t530kkarswv4">{v.number.replace('Том ', 'V')}</span>
            </div>)}
        </div>
        <p className="mt-4 text-center text-sm font-semibold text-[#FECC02]" data-id="element-272" data-mp="2j886qepfzkn6">6 томова + 5 бонуса</p>
      </div>
    </div>;
}
export function PagePlaceholder({
  label,
  title
}: {
  label: string;
  title: string;
}) {
  return <div className="flex h-full w-full flex-col bg-white" aria-hidden="true" data-id="element-273" data-mp="3bwcct1bxdzqe">
      <div className="flex items-center justify-between bg-[#111111] px-4 py-3 text-white" data-id="element-274" data-mp="3gvz0y5tal0dz">
        <span className="text-[11px] font-bold uppercase tracking-widest" data-id="element-275" data-mp="3gxtayp30z83a">ВЕРОНАУКА СПРЕМНА™</span>
      </div>
      <div className="flex flex-1 flex-col gap-3 p-5" data-id="element-276" data-mp="3765pd4t5gl9q">
        <p className="text-[11px] font-bold uppercase tracking-widest text-[#2BB673]" data-id="element-277" data-mp="374kx5lub5ef1">{label}</p>
        <p className="font-serif text-xl leading-tight text-slate-900" data-id="element-278" data-mp="3uu6ue3r4djke">{title}</p>
      </div>
    </div>;
}